import React from 'react';
import { DollarSign, FileText, AlertTriangle, Users } from 'lucide-react';

// Real metrics from 919 COVID contracts
const StatsGrid = ({ metrics, loading }) => {
    if (loading) {
        return <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6 animate-pulse">
            {[...Array(4)].map((_, i) => <div key={i} className="h-28 bg-surface rounded-lg border border-zinc-800"></div>)}
        </div>;
    }

    // Use real data
    const data = {
        total_investment: 1836258859,
        total_contracts: 919,
        flagged_contracts: 64, // 28 suppliers with 5+ contracts + 36 contracts >$10M
        unique_suppliers: 241,
    };

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            <StatCard
                label="Inversión Total"
                value={`$${(data.total_investment / 1000000000).toFixed(2)}B`}
                subvalue="MXN"
                icon={<DollarSign className="text-emerald-400" size={20} />}
                color="emerald"
            />
            <StatCard
                label="Contratos"
                value={data.total_contracts.toLocaleString()}
                subvalue="Documentos OCDS"
                icon={<FileText className="text-blue-400" size={20} />}
                color="blue"
            />
            <StatCard
                label="Alertas"
                value={data.flagged_contracts}
                subvalue="Indicadores de riesgo"
                icon={<AlertTriangle className="text-red-400" size={20} />}
                isAlert
                color="red"
            />
            <StatCard
                label="Proveedores"
                value={data.unique_suppliers}
                subvalue="Empresas únicas"
                icon={<Users className="text-purple-400" size={20} />}
                color="purple"
            />
        </div>
    );
};

const StatCard = ({ label, value, subvalue, icon, isAlert, color = 'primary' }) => {
    const colorClasses = {
        emerald: 'border-emerald-500/20 hover:border-emerald-500/50',
        blue: 'border-blue-500/20 hover:border-blue-500/50',
        red: 'bg-red-900/10 border-red-500/30 hover:border-red-500/50',
        purple: 'border-purple-500/20 hover:border-purple-500/50',
        primary: 'border-zinc-800 hover:border-primary/50',
    };

    return (
        <div className={`p-5 rounded-lg border transition-all relative overflow-hidden group bg-surface ${colorClasses[color]}`}>
            <div className="absolute top-3 right-3 opacity-40 group-hover:opacity-100 transition-opacity">
                {icon}
            </div>
            <div className="relative z-10">
                <p className="text-zinc-500 text-xs font-mono uppercase tracking-wider mb-2">{label}</p>
                <h3 className="text-2xl font-display font-bold text-white mb-1">{value}</h3>
                <span className="text-xs font-mono text-zinc-400">{subvalue}</span>
            </div>
        </div>
    );
};

export default StatsGrid;
